<template>
  <div class="social-wrapper d-flex" style="max-width: 200px; margin-left: -12px;" :class="justify">
    <v-btn
      v-for="(social, idx) in socials"
      icon target="_blank"
      :href="social.url"
      :key="idx"
      class="mr-3"
    >
      <v-icon
        :class="social.className"
        :size="social.size"
        :color="social.color"
      />
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "RowIconSocial",
  props: {
    data: {type: Object, default: () => {}},
    justify: {type: String, default: "justify-space-between"}
  },
  computed: {
    socials() {
      const config = {
        'facebook': {
          className: 'fab fa-facebook-f',
          size: 18,
          color: '#2F80ED',
        },
        'twitter': {
          color: '#56CCF2',
          className: 'fab fa-twitter'
        },
        'instagram': {
          color: '#2F80ED',
          className: 'fab fa-instagram'
        },
        'youtube': {
          color: '#EB5757',
          className: 'fab fa-youtube'
        },
        'tripadvisor': {
          color: '#34E0A1',
          className: 'fab fa-tripadvisor'
        }
      }
      const socials = [];
      Object.keys(config).forEach(socialName => {
        if(!this.data[socialName + 'Url']) return
        const socialConfig = config[socialName]
        if(!socialConfig.size) {
          socialConfig.size = 21;
        }
        socials.push({...socialConfig, url: this.data[socialName + 'Url']})
      })
      return socials
    }
  }
};
</script>

